export const catColors = (n) =>
  ({
    1: ["bg-emerald-500"],
    2: ["bg-emerald-500", "bg-rose-500"],
    3: ["bg-emerald-500", "bg-amber-400", "bg-rose-500"],
  })[n] || ["bg-emerald-500", "bg-amber-400", "bg-sky-500", "bg-rose-500"];

export const DEFAULT_CATS = [
  { key: "c1", label: "On time" },
  { key: "c2", label: "Late" },
  { key: "c3", label: "Incomplete" },
];
export const formCats = (f) => (f.categories?.length ? f.categories : DEFAULT_CATS);

export const STATUS = {
  meets: { label: "Meets goal", text: "text-emerald-700", pill: "bg-emerald-50 text-emerald-700 border-emerald-200", stroke: "#059669" },
  near: { label: "Near goal", text: "text-amber-700", pill: "bg-amber-50 text-amber-700 border-amber-200", stroke: "#d97706" },
  below: { label: "Below goal", text: "text-rose-700", pill: "bg-rose-50 text-rose-700 border-rose-200", stroke: "#e11d48" },
};

export const pct = (v) => (v === null || v === undefined ? "—" : `${Number(v).toFixed(2)}%`);

export const heatClass = (v, goal) => {
  if (v === null || v === undefined) return "bg-slate-50 text-slate-300";
  if (v >= goal) return "bg-emerald-500 text-white";
  if (v >= goal - 5) return "bg-amber-300 text-amber-950";
  if (v >= goal - 15) return "bg-rose-300 text-rose-950";
  return "bg-rose-500 text-white";
};
